import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae85544c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "活动资讯", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-desc" }, "点击查看更多活动资讯", -1))
const _hoisted_5 = {
  key: 0,
  class: "left-box"
}
const _hoisted_6 = { class: "right-box" }
const _hoisted_7 = {
  key: 0,
  class: "right-box-1"
}
const _hoisted_8 = {
  key: 1,
  class: "right-box-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageInfomation = _resolveComponent("ImageInfomation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", {
        class: "info-container",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToInfoList && _ctx.goToInfoList(...args)))
      }, [
        (_ctx.info1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_ImageInfomation, {
                image: _ctx.info1.newsCover,
                link: _ctx.info1.newsUrl,
                title: _ctx.info1.newsTitle,
                desc: _ctx.info1.newsSummary
              }, null, 8, ["image", "link", "title", "desc"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.info2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ImageInfomation, {
                  image: _ctx.info2.newsCover,
                  link: _ctx.info2.newsUrl,
                  title: _ctx.info2.newsTitle,
                  desc: _ctx.info2.newsSummary
                }, null, 8, ["image", "link", "title", "desc"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.info3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_ImageInfomation, {
                  image: _ctx.info3.newsCover,
                  link: _ctx.info3.newsUrl,
                  title: _ctx.info3.newsTitle,
                  desc: _ctx.info3.newsSummary
                }, null, 8, ["image", "link", "title", "desc"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}